import { render } from "./viewpointgps.vue?vue&type=template&id=6d64e2ce&scoped=true"
import script from "./viewpointgps.vue?vue&type=script&lang=js"
export * from "./viewpointgps.vue?vue&type=script&lang=js"

import "./viewpointgps.vue?vue&type=style&index=0&id=6d64e2ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d64e2ce"]])

export default __exports__